import React from "react";
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { Mic as MicIcon } from "@mui/icons-material";

export interface VoiceToTextButtonProps {
  disabled?: boolean;
}

export const VoiceToTextButton: React.FC<VoiceToTextButtonProps> = ({ disabled = false }) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <Tooltip title="Voice to Text">
        <IconButton
          aria-label="Voice to Text"
          disabled={disabled}
          size="medium"
          onClick={() => setModalOpen(true)}
          sx={{
            backgroundColor: "grey.100",
            "&:hover": {
              backgroundColor: "grey.200",
            },
            "&:disabled": {
              color: "text.disabled",
              backgroundColor: "grey.200",
            },
          }}
        >
          <MicIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>Voice to Text</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            This feature is not enabled in your environment.
          </DialogContentText>
          <DialogContentText>
            When enabled, Voice to Text uses AI-powered speech recognition for easier clinical
            note-taking—hands-free, so you can focus on the patient.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
